<template>

  <div class="container-wrapper">

      <rebuySellsDensity />
    
  </div>

</template>

<script>
import rebuySellsDensity from '../components/rebuySellsDensity.vue';

export default {
  name: 'PortfolioDash',
  components: {
    rebuySellsDensity
  }
}
</script>

<style scoped>

</style>
